/**
 * @enum {enumCollectionViewType} The different possible types of collection views
 */
export enum enumCollectionViewType {
  CardsGridView = 'CardsGridView', // cards gridview
  ListView = 'ListView', // list view
}
